module.exports = __webpack_public_path__ + "img/home3.80b38cc6.png";